import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Handle, Position } from '@xyflow/react';

import type { ArcClusterNodeData } from '../types';

interface ArcClusterNodeProps {
  data: ArcClusterNodeData;
  selected?: boolean;
}

/**
 * Arc cluster node showing arc name and event count
 */
export function ArcClusterNode({ data, selected }: ArcClusterNodeProps) {
  return (
    <>
      <Handle type="source" position={Position.Top} id="floating" style={{ opacity: 0, top: '50%', left: '50%' }} />
      <Handle type="target" position={Position.Top} id="floating" style={{ opacity: 0, top: '50%', left: '50%' }} />
      <Paper
        elevation={selected ? 6 : 1}
        sx={{
          p: 2,
          minWidth: 140,
          background: `linear-gradient(135deg, ${data.color}12 0%, ${data.color}06 100%)`,
          border: 1.5,
          borderColor: selected ? data.color : `${data.color}60`,
          borderRadius: 2.5,
          textAlign: 'center',
          transition: 'all 0.2s ease',
          '&:hover': {
            transform: 'scale(1.03)',
            boxShadow: `0 6px 20px ${data.color}25`,
          },
        }}
      >
        <Typography variant="subtitle2" fontWeight={600} sx={{ color: data.color }}>
          {data.label}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {data.eventCount} event{data.eventCount !== 1 ? 's' : ''}
        </Typography>
      </Paper>
    </>
  );
}

export default ArcClusterNode;
